<template>
    <div> 
        <!-- Section 1: Clasificación Clínica -->
        <div class="row mt-3">
            <div class="col-12 mb-3">
                <h6 class="text-uppercase font-weight-bolder text-muted mb-0" style="letter-spacing: 1px; font-size: 11px;">1. Clasificación del Origen</h6>
            </div>

            <div class="col-lg-3 form-group">
                <label class="small text-dark font-weight-bold">Origen <small class="text-danger">*</small></label>
                <select v-model="incapacidad.origen" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.origen.$error && $v.incapacidad.origen.$dirty}">
                    <option value="">Seleccione...</option>
                    <option v-for="(opt, idx) in opcionesOrigen" :key="`origen-${idx}`" :value="opt">{{ opt }}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.origen.required">Requerido</div>
            </div>

            <div class="col-lg-3 form-group">
                <label class="small text-dark font-weight-bold">Clase <small class="text-danger">*</small></label>
                <select v-model="incapacidad.clase" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.clase.$error && $v.incapacidad.clase.$dirty}">
                    <option value="">Seleccione...</option>
                    <option v-for="(opt, idx) in opcionesClase" :key="`clase-${idx}`" :value="opt">{{ opt }}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.clase.required">Requerido</div>
            </div>

            <div class="col-lg-6 form-group">
                <label class="small text-dark font-weight-bold">Tipología <small class="text-danger">*</small></label>
                <select v-model="incapacidad.tipo_incapacidad" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.tipo_incapacidad.$error && $v.incapacidad.tipo_incapacidad.$dirty}">
                    <option value="">Seleccione...</option>
                    <option v-for="(opt, idx) in opcionesTipoIncapacidad" :key="`tipo-${idx}`" :value="opt">{{ opt }}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.tipo_incapacidad.required">Requerido</div>
            </div>
        </div>

        <div class="my-3"><hr class="border-light" /></div>

        <!-- Section 2: Logística y Permiso -->
        <div class="row">
            <div class="col-12 mb-3">
                <h6 class="text-uppercase font-weight-bolder text-muted mb-0" style="letter-spacing: 1px; font-size: 11px;">2. Logística y Fechas</h6>
            </div>

            <div class="col-lg-6 form-group">
                <label class="small text-dark font-weight-bold">Grupo de servicios <small class="text-danger">*</small></label>
                <select v-model="incapacidad.grupo_servicios" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.grupo_servicios.$error && $v.incapacidad.grupo_servicios.$dirty}">
                    <option value="">Seleccione...</option>
                    <option v-for="(opt, idx) in opcionesGrupoServicios" :key="`grupo-${idx}`" :value="opt">{{ opt }}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.grupo_servicios.required">Requerido</div>
            </div>

            <div class="col-lg-6 form-group">
                <label class="small text-dark font-weight-bold">Modalidad de la prestación <small class="text-danger">*</small></label>
                <select v-model="incapacidad.modalidad_prestacion" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.modalidad_prestacion.$error && $v.incapacidad.modalidad_prestacion.$dirty}">
                    <option value="">Seleccione...</option>
                    <option v-for="(opt, idx) in opcionesModalidad" :key="`mod-${idx}`" :value="opt">{{ opt }}</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.modalidad_prestacion.required">Requerido</div>
            </div>

            <div class="col-lg-6 form-group">
                <label class="small text-dark font-weight-bold">Incapacidad retroactiva <small class="text-danger">*</small></label>
                <select v-model="incapacidad.es_retroactiva" class="form-control form-control-sm"
                :class="{'is-invalid' : $v.incapacidad.es_retroactiva.$error && $v.incapacidad.es_retroactiva.$dirty}">
                    <option value="">Seleccione...</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                </select>
                <div class="invalid-feedback" v-if="!$v.incapacidad.es_retroactiva.required">Requerido</div>
            </div>

            
            <div class="col-lg-6 form-group overflow-hidden">
                <transition name="slide-fade">
                    <div v-if="incapacidad.es_retroactiva === 'Si'">
                        <label class="small text-danger font-weight-bold">Motivo retroactiva <small class="text-danger">*</small></label>
                        <select v-model="incapacidad.motivo_retroactiva" class="form-control form-control-sm"
                        :class="{'is-invalid' : $v.incapacidad.motivo_retroactiva.$error && $v.incapacidad.motivo_retroactiva.$dirty}">
                            <option value="">Seleccione...</option>
                            <option v-for="(opt, idx) in opcionesMotivoRetroactiva" :key="`motivo-${idx}`" :value="opt">{{ opt }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="!$v.incapacidad.motivo_retroactiva.required">Requerido</div>
                    </div>
                </transition>
            </div>
            
            <div class="col-lg-4 form-group">
                <label class="small mb-1 font-weight-bolder">Desde <small class="text-danger">*</small></label>
                <input  v-model="incapacidad.fecha_inicial" class="form-control form-control-sm" type="date"
                :class="{
                    'is-invalid' : $v.incapacidad.fecha_inicial.$error && $v.incapacidad.fecha_inicial.$dirty
                }"/>
                <span class="invalid-feedback" v-if="!$v.incapacidad.fecha_inicial.required">
                    Requerido
                </span>
            </div> 

            <div class="col-lg-4 form-group">
                <label class="small mb-1 font-weight-bolder">Hasta <small class="text-danger">*</small></label>
                <input  v-model="incapacidad.fecha_final" class="form-control form-control-sm" type="date"
                :class="{
                    'is-invalid' : $v.incapacidad.fecha_final.$error && $v.incapacidad.fecha_final.$dirty
                }"/>
                <span class="invalid-feedback" v-if="!$v.incapacidad.fecha_final.required">
                    Requerido
                </span>
            </div>

            <div class="col-lg-4 form-group">
                <label class="small mb-1 font-weight-bolder text-primary">Total Días a Otorgar</label>
                <input class="form-control form-control-sm font-weight-bold" type="text" readonly :value="totalDias + (totalDias === 1 ? ' Día' : ' Días')"/>
            </div>
    
            <div class="col-lg-12 form-group">
                <label  class="form-label font-weight-bolder"><i class="far fa-comment-alt fa-fw"></i> Descripción de la Incapacidad Clínca <small class="text-danger">*</small></label>
                <div>
                    <textarea  v-model="incapacidad.descripcion" class="form-control" rows="3" placeholder="Detalle médico complementario del permiso..." :class="{'is-invalid':$v.incapacidad.descripcion.$error && $v.incapacidad.descripcion.$dirty}"></textarea>
                    <span class="text-danger text-sm" v-if="!$v.incapacidad.descripcion.minLengthValue">Debe ingresar un minimo de 20 caracteres</span>
                </div>
            </div>   
        </div>

        <button class="btn btn-success btn-sm mt-2" @click="guardar()">
            <i class="fas fa-save"></i>&nbsp;Guardar
        </button>
    </div>
</template>
<script>
import incapacidadService from '../../../../services/incapacidadService';
import {minLength, required, requiredIf} from "vuelidate/lib/validators";
import Toast from '../../../../components/common/utilities/toast';
import dayjs from "dayjs";


export default {
    props:['idHistoria','usuario'],
    data() {
        return{
            opcionesOrigen: ['Origen Común', 'Origen Laboral'],
            opcionesClase: ['Inicial', 'Prórroga'],
            opcionesTipoIncapacidad: ['Enfermedad general', 'Licencia de maternidad', 'Licencia de paternidad', 'Accidente de tránsito'],
            opcionesGrupoServicios: [
                'Consulta externa', 
                'Apoyo diagnóstico clínico y complementación terapéutica', 
                'Internación', 
                'Quirúrgico', 
                'Atención inmediata'
            ],
            opcionesModalidad: [
                'Intramural', 
                'Extramural unidad móvil', 
                'Extramural domiciliaria', 
                'Extramural jornada de salud', 
                'Telemedicina interactiva', 
                'Telemedicina no interactiva', 
                'Telemedicina telexperticia', 
                'Telemedicina telemonitoreo'
            ],
            opcionesMotivoRetroactiva: [
                'Urgencias o internación del paciente', 
                'Trastorno de memoria, confusión mental, desorientación en persona tiempo y lugar, otras alteraciones de la esfera psíquica, orgánica o funcional según criterio médico u odontólogo', 
                'Evento catastrófico y terrorista'
            ],
            incapacidad:{
                id_historia:this.idHistoria,
                origen: '',
                clase: '',
                tipo_incapacidad: '',
                grupo_servicios: '',
                modalidad_prestacion: '',
                es_retroactiva: '',
                motivo_retroactiva: '',
                fecha_inicial:'',
                fecha_final:'',
                total_dias:'',
                descripcion:''
            }
        }
    },
    validations (){
        return {
            incapacidad:{ 
                origen: {required},
                clase: {required},
                tipo_incapacidad: {required},
                grupo_servicios: {required},
                modalidad_prestacion: {required},
                es_retroactiva: {required},
                motivo_retroactiva: {
                    required: requiredIf(function() {
                        return this.incapacidad.es_retroactiva === 'Si';
                    })
                },
                fecha_inicial:{required},
                fecha_final:{required},
                descripcion:{
                    required,
                    minLengthValue:minLength(20),
                },
            }
        }
    },
    methods: {
        async guardar() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return
                }
               
                this.LoaderSpinnerShow();
                this.incapacidad.total_dias = this.totalDias;
                await incapacidadService.store(this.incapacidad);
                this.limpiarCampos();
                this.LoaderSpinnerHide();
                
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con exito'
                });
                this.$emit('cargar-incapacidades');
            }catch (error) {
                console.error(error);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        limpiarCampos(){
            this.incapacidad={
                id_historia:this.idHistoria,
                origen: '',
                clase: '',
                tipo_incapacidad: '',
                grupo_servicios: '',
                modalidad_prestacion: '',
                es_retroactiva: '',
                motivo_retroactiva: '',
                fecha_inicial:'',
                fecha_final:'',
                total_dias:'',
                descripcion:''
            };
            this.$v.$reset();
        },
    },
    computed:{
        totalDias() {
            if (!this.incapacidad.fecha_inicial || !this.incapacidad.fecha_final) {
                return '';
            }
            const startDate = dayjs(this.incapacidad.fecha_inicial);
            const endDate = dayjs(this.incapacidad.fecha_final);
            return endDate.diff(startDate, 'day')+1;
        }
    }
}
</script>

<style scoped>
/* Spring Physics Animation for Slide-Fade elements */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-15px);
  opacity: 0;
}
</style>
